<template>
  <div class="text-sm text-gray-700 px-2 pt-2 flex flex-col items-end">
    <div
      class="flex items-center justify-center py-1"
      v-for="(date, index) in nonNullDates"
      :key="index"
    >
      <div class="w-24 text-right" v-text="i18n[index]"></div>
      <div class="w-4 mx-5">
        <div class="w-4 h-4 rounded-full status -mt-1" :class="index"></div>
      </div>
      <div class="w-48 flex items-center text-right">
        <div class="" v-text="date.date"></div>
        <div class="text-center flex-grow">&nbsp;</div>
        <div class="" v-text="date.hour"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dates", "i18n"],
  computed: {
    nonNullDates() {
      let result = {};
      let previousDate = "";
      Object.keys(this.dates).forEach((key) => {
        const item = this.dates[key];
        if (item !== null) {
          if (item.date == previousDate) {
            item.date = "";
          } else {
            previousDate = item.date;
          }
          result[key] = item;
        }
      });

      return result;
    },
  },
};
</script>
